import { getViewport } from '@nova/utils'

document.addEventListener('DOMContentLoaded', () => {
  const $productCarousels = document.querySelectorAll(
    '.js-product-carousel-carousel',
  )

  if ($productCarousels.length === 0) return

  updateProductCarouselAttribute()

  function updateProductCarouselAttribute() {
    productCarouselSizeEvent($productCarousels)

    for (const $carousel of $productCarousels) {
      const $navBtns = $carousel.shadowRoot.querySelectorAll(
        '.carousel__navigation-button',
      )
      initProductCarouselNavBtns($navBtns)
      observeProductCarouselNavBtns($navBtns)

      const viewport = getViewport()
      switch (viewport) {
        case 'small-mobile':
        case 'mobile':
          $carousel.setAttribute('slides-per-page', 1.5)
          break
        case 'tablet':
          $carousel.setAttribute('slides-per-page', 2)
          break
        case 'desktop':
          $carousel.setAttribute('slides-per-page', 3.25)
          break
        case 'large-desktop':
          $carousel.setAttribute('slides-per-page', 4)
          break
        default:
          $carousel.setAttribute('slides-per-page', 3.25)
          break
      }
    }
  }

  window.addEventListener('nova:resize-width', updateProductCarouselAttribute)
})

const productCarouselSizeEvent = (carousels) => {
  for (const carousel of carousels) {
    const $carouselBase = carousel.shadowRoot.querySelector('#scroll-container')
    const $carouselBtns = carousel.shadowRoot.querySelectorAll(
      '.carousel__navigation-button',
    )
    if ($carouselBtns.length === 0 || !$carouselBase) return
    if (window.innerWidth < 768) return

    for (const $button of $carouselBtns) {
      $button.style.display =
        $carouselBase.scrollWidth > $carouselBase.clientWidth ? 'flex' : 'none'
    }
  }
}

const observeProductCarouselNavBtns = (buttons) => {
  const observerCallback = (mutationsList) => {
    for (const mutation of mutationsList) {
      if (
        mutation.type === 'attributes' &&
        mutation.attributeName === 'class'
      ) {
        const targetElement = mutation.target
        targetElement.style.opacity = targetElement.classList.contains(
          'carousel__navigation-button--disabled',
        )
          ? 0
          : 1
        targetElement.style.cursor = targetElement.classList.contains(
          'carousel__navigation-button--disabled',
        )
          ? 'default'
          : 'pointer'
      }
    }
  }
  const observerConfig = { attributes: true, attributeFilter: ['class'] }
  const observer = new MutationObserver(observerCallback)
  for (const button of buttons) {
    observer.observe(button, observerConfig)
  }
}

const initProductCarouselNavBtns = (buttons) => {
  for (const button of buttons) {
    button.style.opacity = button.classList.contains(
      'carousel__navigation-button--disabled',
    )
      ? 0
      : 1
    button.style.cursor = button.classList.contains(
      'carousel__navigation-button--disabled',
    )
      ? 'default'
      : 'pointer'
  }
}
